import { useTranslation } from 'react-i18next';
import { TabHeader, TabsHeaders } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './IndustryTabsHeaders.module.scss';

export const industryHeadings = [
    'Retail Stores',
    'Startups',
    'Construction Companies',
    'Real Estate',
    'Clothing Shops',
] as const;

export type IndustryKey = (typeof industryHeadings)[number];

const IndustryTabsHeaders = () => {
    useStyles(stylesheet);
    const { t } = useTranslation();

    const industryHeadingsMap: Record<IndustryKey, string> = {
        'Retail Stores': t('Vista Logos > Logomaker Anywhere > Industry Tab > Retail.value'),
        Startups: t('Vista Logos > Logomaker Anywhere > Industry Tab > Startups.value'),
        'Construction Companies': t(
            'Vista Logos > Logomaker Anywhere > Industry Tab > Construction.value',
        ),
        'Real Estate': t('Vista Logos > Logomaker Anywhere > Industry Tab > Real Estate.value'),
        'Clothing Shops': t('Vista Logos > Logomaker Anywhere > Industry Tab > Clothing.value'),
    };

    return (
        <TabsHeaders
            className={styles.tabsHeaders}
            paddingBottom={6}
            aria-labelledby="industry-tabs"
        >
            {Object.entries(industryHeadingsMap).map(([industryKey, heading]) => (
                <TabHeader key={industryKey} tabId={industryKey}>
                    {heading}
                </TabHeader>
            ))}
        </TabsHeaders>
    );
};

export default IndustryTabsHeaders;
